import { render } from "./LetterBoxE.vue?vue&type=template&id=42089d16&scoped=true"
import script from "./LetterBoxE.vue?vue&type=script&lang=js"
export * from "./LetterBoxE.vue?vue&type=script&lang=js"

import "./LetterBoxE.vue?vue&type=style&index=0&id=42089d16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42089d16"

export default script